var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDotsIcon = function SvgDotsIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_523_286)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 3C16.971 3 21 7.029 21 12C21 16.971 16.971 21 12 21C7.029 21 3 16.971 3 12C3 7.029 7.029 3 12 3Z",
    stroke: "#AEAEB2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.001 12.375C12.208 12.375 12.376 12.207 12.374 12C12.374 11.793 12.206 11.625 11.999 11.625C11.792 11.625 11.624 11.793 11.624 12C11.625 12.207 11.793 12.375 12.001 12.375Z",
    stroke: "#AEAEB2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.00102 12.375C8.20802 12.375 8.37602 12.207 8.37402 12C8.37402 11.793 8.20602 11.625 7.99902 11.625C7.79202 11.625 7.62402 11.793 7.62402 12C7.62502 12.207 7.79302 12.375 8.00102 12.375Z",
    stroke: "#AEAEB2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.001 12.375C16.208 12.375 16.376 12.207 16.374 12C16.374 11.793 16.206 11.625 15.999 11.625C15.792 11.625 15.624 11.793 15.624 12C15.625 12.207 15.793 12.375 16.001 12.375Z",
    stroke: "#AEAEB2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_523_286"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
};
export { SvgDotsIcon as ReactComponent };
export default __webpack_public_path__ + "dots-icon.svg";